/**
 * This place where we put out
 * Trip definitions method
 */
export const actions = {
  getRestaurantBooking: 'getRestaurantBooking',
  createRestaurantBooking: 'createRestaurantBooking',
  updateRestaurantBooking: 'updateRestaurantBooking',
  cancelRestaurantBooking: 'cancelRestaurantBooking'
};

export const mutations = {
  setTrips: 'setTrips'
};

export default {
  actions,
  mutations
};
